import React from 'react';
import variables from '../../styles/variables.module.scss';
import Highlight from '../../components/Highlight';

import hero from '../../assets/hero/mopz-hero@2x-min.png';
import env1Double from '../../assets/envImages/mopz-double1-min.jpg';

import env2Double from '../../assets/envImages/mopz-double2-min.jpg';
import footerBanner from '../../assets/envImages/mopz-footerBanner@2x-min.png';
import extraimg1 from '../../assets/frames/mopz-extraimg1@2x-min.png';
import extraimg2 from '../../assets/frames/mopz-extraimg2@2x-min.png';
import extraimg3 from '../../assets/frames/mopz-extraimg3@2x-min.png';

export default {
  path: '/cases/mopz',
  color: variables.mopz,
  hero: { fall: hero },
  xtra: [
    { fall: extraimg1 },
    { fall: extraimg2 },
    { fall: extraimg3 },
  ],
  environments: { env1: env1Double, env2: env2Double },
  footerBanner: { fall: footerBanner },
  quoteData: {
    quote: 'Before starting, we had very high demands on the software development partner we would choose. We App felt right from the start and they have done a really great job with our AR application. It\'s so great seeing our vision come to life.',
    name: 'Pierre Karlsson',
    profession: 'Co-Founder, Mopz',
  },
  title: 'Mopz',
  sideHeadingFirst: 'iOS & Android application',
  sideHeadingSecond: 'Developed in Swift and Android',
  infoTitle: 'What we built',
  infoBody:
  <span>
    For this project, We App has built powerful user applications that work across both Android and iOS. Leveraging both the power of
    {' '}
    <Highlight>ArKit</Highlight>
    {' and '}
    <Highlight>ArCore</Highlight>
.
    <br />
    <br />
    Tech stack used:
    {' '}
    <Highlight>Java, Swift, Firebase, NodeJS, mongoDB</Highlight>
    .
  </span>,
  infoData: {
    Scope: ['Scope', 'Project management', 'User experience', 'UI & UX design'],
    Deliverables: ['Deliverables', 'iOS development', 'Android development', 'Cross-platform', 'Software development'],
    Goal: ['Goal', 'Project management', 'User experience', 'UI & UX design', 'Maintanance/support'],
  },
  titleBodyData: {
    0: {
      title: 'A social network, based on Augmented Reality',
      body:
  <span>
    Mopz is developing the future of social networks, in the form of an augmented reality app, where users can interact using messages, paintings, objects and emojis, that exist as a layer on top of the normal world.
    <br />
    <br />
    In the future, the technology solution can also be used in communication between businesses and consumers, by adding an augmented layer of information on top of everyday objects and locations.
  </span>,
    },
    1: {
      title: 'Digital art for everyone to behold',
      body: <span>Apart from acting as a peer-to-peer social network and messaging service. Mopz can also be used to create public displays of art and literature, enabling city-goers to experience an additional layer of beauty and information, about the space in which they move.</span>,
    },
  },
};
